module.exports = __webpack_public_path__ + "assets/img/btn-detail-10193e89.png";